import React, { Component } from 'react';

import {
  BrowserRouter as Router,
  Route,
  Switch
} from 'react-router-dom'

import Landing from './Views/Landing/Landing'
import Footer from './Views/Footer/Footer'
import Terms from './Views/Terms/Terms'
import Jobs from './Views/Jobs/Jobs'
import JobDescription from './Views/Jobs/JobDescription'
import PageDoesNotExist from './Views/404/PageDoesNotExist'
import Support from './Views/Support/Support'


import './App.css'
class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Switch>
            <Route exact path='/' component={Landing}/>
            <Route path='/terms' component={Terms}/>
            <Route exact path='/jobs' component={Jobs}/>
            <Route path='/jobs/:job' component={JobDescription}/>
            <Route path='/support' component={Support}/>
            <Route component={PageDoesNotExist}/>
          </Switch>
          <Footer/>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js